module.exports = __webpack_public_path__ + "img/thumb-josh-hidayat.f6394df5.jpg";